import React, { createContext, useState, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('light');

    const onThemeChange = (event) => {
        setTheme(event.target.value);
    };

    const themeOptions = [
        {
            value: 'light',
            id: 'light',
            labelText: 'Light',
            checked: theme === 'light'
        },
        {
            value: 'dark',
            id: 'dark',
            labelText: 'Dark',
            checked: theme === 'dark'
        },
        {
            value: 'garden',
            id: 'garden',
            labelText: 'Garden',
            checked: theme === 'garden'
        }
    ];

    return (
        <ThemeContext.Provider value={{ theme, onThemeChange, themeOptions }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
